import uuid from "react-uuid";

/**
 * Вложенный блок-контейнер для элементов (текст, кнопки) — та же схема, что
 * в initialStylesForComponents для block-video / block-video-v2. Нужен для
 * старых блоков, сохранённых до появления этого уровня: у них components
 * пустой или отсутствует, и класть элемент было некуда.
 */
const createEmptyBlock = () => ({
	id: uuid(),
	name: "block",
	hover: {
		hoverText: false,
	},
	styles: {
		justifyContent: "center",
	},
	components: [],
});

const getResult = (collection, activeId, itemForChanged) => {
	let result = [];
	for (let item of collection) {
		if (item.id === activeId) {
			result = [...result, itemForChanged];
		} else {
			result = [...result, item];
		}
	}
	return result;
};

export const addNewStyle = (
	componentCollection,
	id,
	currentLang,
	type,
	params,
	replacement,
	replacementId
) => {
	let firstLevel = componentCollection.filter(
		(item) => item.id === id[0]
	)?.[0];
	let twoLevelComponents = firstLevel.components;
	let twoLevel = twoLevelComponents?.filter((item) => item.id === id[1])[0];
	let threeLevelComponents = twoLevel?.components;
	let threeLevel = threeLevelComponents?.filter(
		(item) => item.id === id[2]
	)[0];
	let fourLevelComponents = threeLevel && threeLevel[currentLang];
	let fourLevel = fourLevelComponents?.filter((item) => item.id === id[3])[0];
	let threeLevelComponentsReplacement = twoLevel?.componentsReplacement;
	let threeLevelReplacement = threeLevelComponentsReplacement?.filter(
		(item) => item.id === (replacementId ? replacementId[2] : id[2])
	)[0];
	let fourLevelComponentsReplacement =
		threeLevelReplacement && threeLevelReplacement[currentLang];
	let fourLevelReplacement = fourLevelComponentsReplacement?.filter(
		(item) => item.id === (replacementId ? replacementId[3] : id[3])
	)[0];

	// Проверка на паддинги
	if (id.length === 2 && params.padding) {
		let res = false;
		params.padding.forEach((i) => {
			i !== "0px" && (res = true);
		});
		twoLevel.isPaddingImage = res;
	}

	const selectProperty = (level) => {
		if (
			type === "styles" ||
			type === "image" ||
			type === "stories" ||
			type === "text" ||
			type === "datePiker" ||
			type === "link" ||
			type === "view" ||
			type === "colorDress" ||
			type === "hover" ||
			type === "animate" ||
			type === "datePikerReplacement" ||
			type === "datePikerDelete" ||
			type === "autoplay" ||
			type === "nameStyles" ||
			type === "priceStyles" ||
			type === "meta" ||
			type === "titleStyles" ||
			type === "title" ||
			type === "imageLocales"
		) {
			if (type === "stories") {
				return {
					...level,
					[type]: [...params],
				};
			}
			return {
				...level,
				[type]: {
					...level[type],
					...params,
				},
			};
		}
		if (
			type === "count" ||
			type === "category" ||
			type === "video" ||
			type === "dash_src" ||
			type === "textSliced" ||
			type === "isPreview" ||
			type === "deadline" ||
			type === "type" ||
			type === "isPlay" ||
			type === "isProgressBar" ||
			type === "isPagination" ||
			type === "isAutoplay" ||
			type === "datePikerDelete" ||
			type === "blockTheme" ||
			type === "sliderPosition" ||
			type === "slidePerGroup" ||
			type === "slidePerView" ||
			type === "centeredSlides" ||
			type === "isDarkPagination" ||
			type === "randomShowComponent" ||
			type === "elementOutside" ||
			type === "videoId" ||
			type === "slidesOffsetAfter" ||
			type === "slidesOffsetBefore" ||
			type === "elementPosition" ||
			type === "videoControls" ||
			type === "showSubjectPhoto" ||
			type === "nameEnabled" ||
			type === "priceEnabled" ||
			type === "cardsPerRow"
		) {
			return {
				...level,
				[type]: params,
			};
		}
		/**
		 * Словари, которые нужно заменять целиком, а не мержить.
		 *
		 * filters приходит из панели уже полным объектом: снятая галочка
		 * удаляет ключ группы, «Сбросить» присылает {}. При обычном мерже
		 * (`{...level[type], ...params}`) удалённые ключи оставались в
		 * компоненте — сброс визуально срабатывал, а товары приезжали
		 * по старым фильтрам.
		 */
		if (type === "filters") {
			return {
				...level,
				[type]: { ...params },
			};
		}
		if (type === "lang" || type === "shop") {
			return {
				...level,
				...params,
			};
		}

		/**
		 * Неизвестный type — параметр забыли дописать в списки выше.
		 *
		 * Раньше здесь возвращался undefined, и getResult клал его в
		 * коллекцию вместо компонента: блок исчезал, а редактор падал
		 * дальше по стеку в useActiveComponent на `item.id` — по этой
		 * ошибке причину не найти. Возвращаем уровень нетронутым и
		 * шумим в консоль: настройка не применится, но состояние цело.
		 */
		console.error(
			`[editorHelpers] addNewStyle: неизвестный параметр "${type}" — добавьте его в selectProperty, иначе он не сохранится`
		);
		return level;
	};

	if (replacement) {
		const isFourLevel = () => {
			if ((replacementId && replacementId[3]) || id[3]) {
				return {
					...threeLevelReplacement,
					[currentLang]: getResult(
						fourLevelComponentsReplacement,
						(replacementId && replacementId[3]) || id[3],
						selectProperty(fourLevelReplacement)
					),
				};
			}
			return selectProperty(threeLevelReplacement);
		};
		return getResult(
			componentCollection,
			replacementId ? replacementId[0] : id[0],
			{
				...firstLevel,
				components: getResult(
					twoLevelComponents,
					replacementId ? replacementId[1] : id[1],
					{
						...twoLevel,
						componentsReplacement: getResult(
							threeLevelComponentsReplacement,
							replacementId ? replacementId[2] : id[2],
							isFourLevel()
						),
					}
				),
			}
		);
	}

	if (id?.length === 1) {
		return getResult(componentCollection, id[0], selectProperty(firstLevel));
	}
	if (id?.length === 2) {
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(
				twoLevelComponents,
				id[1],
				selectProperty(twoLevel)
			),
		});
	}
	if (id?.length === 3) {
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: getResult(
					threeLevelComponents,
					id[2],
					selectProperty(threeLevel)
				),
			}),
		});
	}

	if (id?.length === 4) {
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: getResult(threeLevelComponents, id[2], {
					...threeLevel,
					[currentLang]: getResult(
						fourLevelComponents,
						id[3],
						selectProperty(fourLevel)
					),
				}),
			}),
		});
	}
};

export const deleteComponent = (componentCollection, id, currentLang) => {
	let itemForChanged = {};

	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel?.components;
	let twoLevel = twoLevelComponents?.filter((item) => item.id === id[1])[0];
	let threeLevelComponents = twoLevel?.components;
	let threeLevel = threeLevelComponents?.filter(
		(item) => item.id === id[2]
	)[0];
	let fourLevelComponents = threeLevel && threeLevel[currentLang];
	let threeLevelClear = threeLevelComponents?.filter(
		(item) => item.id !== id[2]
	);
	let fourLevelClear = fourLevelComponents?.filter(
		(item) => item.id !== id[3]
	);

	let threeLevelComponentsReplacement = twoLevel?.componentsReplacement;
	let threeLevelClearReplacement = threeLevelComponentsReplacement?.filter(
		(item) => item.id !== id[2]
	);

	if (
		id?.length === 1 ||
		(id?.length === 2 && twoLevelComponents.length === 1)
	) {
		return componentCollection.filter((item) => item.id !== id[0]);
	}
	if (id?.length === 2) {
		let newTwoLevelComponents = [];
		let newFirstLevel = {};
		let key = 0;
		for (let item of twoLevelComponents) {
			if (item.id !== id[1]) {
				newTwoLevelComponents = [...newTwoLevelComponents, item];
				key++;
			} else if (
				firstLevel.name === "block-image" ||
				firstLevel.name === "block-image-w-half-h" ||
				firstLevel.name === "block-image-full-screen"
			) {
				let newGridTemplateColumns = [
					...firstLevel.styles.gridTemplateColumns,
				];
				newGridTemplateColumns.splice(key, 1);
				newFirstLevel = {
					...firstLevel,
					styles: {
						...firstLevel.styles,
						gridTemplateColumns: newGridTemplateColumns,
					},
				};
			}
		}
		itemForChanged = {
			...newFirstLevel,
			components: newTwoLevelComponents,
		};
		let result = [];
		for (let item of componentCollection) {
			if (item.id === id[0]) {
				result = [...result, itemForChanged];
			} else {
				result = [...result, item];
			}
		}
		return result;
	}
	if (id?.length === 3) {
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: threeLevelClear,
				componentsReplacement: threeLevelClearReplacement,
			}),
		});
	}

	if (id?.length === 4) {
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: !fourLevelClear.length
					? threeLevelClear
					: getResult(threeLevelComponents, id[2], {
							...threeLevel,
							[currentLang]: fourLevelClear,
						}),
			}),
		});
	}
};

export const deleteBlockSwiper = (componentCollection, id) => {
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel?.components;
	let twoLevelClear = twoLevelComponents?.filter((item) => item.id !== id[1]);
	return getResult(componentCollection, id[0], {
		...firstLevel,
		components: twoLevelClear,
	});
};

export const deleteKeyObject = (componentCollection, id, key) => {
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel?.components;
	let twoLevel = twoLevelComponents?.filter((item) => item.id === id[1])[0];
	let threeLevelComponents = twoLevel?.components;
	let threeLevel = threeLevelComponents?.filter(
		(item) => item.id === id[2]
	)[0];
	if (id?.length === 3) {
		delete threeLevel[key];

		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: getResult(threeLevelComponents, id[2], {
					...threeLevel,
				}),
			}),
		});
	}
};

export const addBlock = (componentCollection, id, block) => {
	let itemForChanged = {};
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let newGridTemplateColumns = [
		...firstLevel.styles.gridTemplateColumns,
		"1fr",
	];
	let newComponentsTwoLevel = [...firstLevel.components, block];
	itemForChanged = {
		...firstLevel,
		components: newComponentsTwoLevel,
		styles: {
			...firstLevel.styles,
			gridTemplateColumns: newGridTemplateColumns,
		},
	};

	let result = [];
	for (let item of componentCollection) {
		if (item.id === id[0]) {
			result = [...result, itemForChanged];
		} else {
			result = [...result, item];
		}
	}
	return result;
};

export const addBlockSwiper = (componentCollection, id, block) => {
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel.components;

	return getResult(componentCollection, id[0], {
		...firstLevel,
		components: [...twoLevelComponents, block],
	});
};

export const addElement = (componentCollection, id, element) => {
	const sticky = ["text_sticky", "button_outline_sticky"];

	const firstLevel = componentCollection.filter(
		(item) => item.id === id[0]
	)[0];

	if (!firstLevel) {
		console.error(
			`[editorHelpers] addElement: контейнер "${id[0]}" не найден — элемент не добавлен`
		);
		return componentCollection;
	}

	const twoLevelComponents = firstLevel.components ?? [];

	/**
	 * Правая кнопка выделяет контейнер целиком (activeComponent длиной 1),
	 * и id[1] здесь undefined. Раньше на этом падал `threeLevelComponents.filter`:
	 * панель «Добавить элемент» открывалась (block-video есть в AddComponent),
	 * но кнопки «текст»/«кнопка» ничего не делали. Берём первый вложенный блок —
	 * тот же, что выделяется левой кнопкой, — и кладём элемент в него.
	 */
	const existingTwoLevel =
		twoLevelComponents.filter((item) => item.id === id[1])[0] ??
		twoLevelComponents[0];

	/**
	 * У блоков, сохранённых до появления вложенного уровня (в основном мобильная
	 * коллекция), components пустой или отсутствует. Раньше элемент класть было
	 * некуда и добавление молча не срабатывало — заводим блок на лету.
	 */
	const twoLevel = existingTwoLevel?.components
		? existingTwoLevel
		: createEmptyBlock();

	const nextTwoLevelComponents = existingTwoLevel?.components
		? twoLevelComponents
		: [...twoLevelComponents, twoLevel];

	const isSticky = sticky.includes(element.name);

	const threeLevelComponents = twoLevel.components.filter((item) =>
		isSticky ? sticky.includes(item.name) : !sticky.includes(item.name)
	);

	return getResult(componentCollection, id[0], {
		...firstLevel,
		components: getResult(nextTwoLevelComponents, twoLevel.id, {
			...twoLevel,
			blockSticky: isSticky,
			components: [...threeLevelComponents, element],
		}),
	});
};

export const addElementReplacement = (componentCollection, id, element) => {
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel.components;
	let twoLevel = twoLevelComponents.filter((item) => item.id === id[1])[0];

	let threeLevelComponentsReplacement = twoLevel?.componentsReplacement;
	let filter = threeLevelComponentsReplacement?.filter(
		(item) => item.id !== id[2]
	);

	return getResult(componentCollection, id[0], {
		...firstLevel,
		components: getResult(
			twoLevelComponents,
			id[1],
			element
				? filter
					? {
							...twoLevel,
							componentsReplacement: [...filter, element],
						}
					: { ...twoLevel, componentsReplacement: [element] }
				: filter
					? { ...twoLevel, componentsReplacement: [...filter] }
					: { ...twoLevel, componentsReplacement: [] }
		),
	});
};

export const addSliced = (
	componentCollection,
	id,
	sliced,
	currentLang,
	isReplacement
) => {
	let firstLevel = componentCollection.filter((item) => item.id === id[0])[0];
	let twoLevelComponents = firstLevel.components;
	let twoLevel = twoLevelComponents?.filter((item) => item.id === id[1])[0];
	let threeLevelComponents = twoLevel?.components;
	let threeLevel = threeLevelComponents?.filter(
		(item) => item.id === id[2]
	)[0];
	let fourLevelComponents = threeLevel && threeLevel[currentLang];

	let threeLevelComponentsReplacement = twoLevel?.componentsReplacement;
	let threeLevelReplacement = threeLevelComponentsReplacement?.filter(
		(item) => item.id === id[2]
	)[0];
	let fourLevelComponentsReplacement =
		threeLevelReplacement && threeLevelReplacement[currentLang];

	const getIsReplacement = () => {
		if (!isReplacement) {
			return {
				components: getResult(threeLevelComponents, id[2], {
					...threeLevel,
					[currentLang]: [...fourLevelComponents, sliced],
				}),
			};
		}
		return {
			componentsReplacement: getResult(
				threeLevelComponentsReplacement,
				id[2],
				{
					...threeLevelReplacement,
					[currentLang]: [...fourLevelComponentsReplacement, sliced],
				}
			),
		};
	};

	return getResult(componentCollection, id[0], {
		...firstLevel,
		components: getResult(twoLevelComponents, id[1], {
			...twoLevel,
			...getIsReplacement(),
		}),
	});
};

/**
 * Контейнеры, у которых styles.gridTemplateColumns — массив, параллельный
 * components: сколько блоков, столько колонок. При дублировании блока колонку
 * нужно вставить следом за исходной, иначе сетка разъедется (см. addBlock).
 */
const GRID_COLUMN_CONTAINERS = [
	"block-image",
	"block-image-w-half-h",
	"block-image-full-screen",
];

const isPlainObject = (value) =>
	typeof value === "object" && value !== null && !Array.isArray(value);

/**
 * Глубокая копия поддерева с новыми id. Числовые id не трогаем — их использует
 * не редактор, а данные компонента (порядковый id сториса и т.п.). Ссылки на
 * старые id (styles.parentId у sliced) переписываем на новые.
 */
const cloneWithNewIds = (node, rootId) => {
	const idMap = {};

	const walk = (value) => {
		if (Array.isArray(value)) {
			return value.map(walk);
		}
		if (!isPlainObject(value)) {
			return value;
		}

		const result = {};
		for (const key of Object.keys(value)) {
			result[key] = walk(value[key]);
		}
		if (typeof value.id === "string") {
			const nextId = uuid();
			idMap[value.id] = nextId;
			result.id = nextId;
		}
		return result;
	};

	const clone = walk(node);

	if (rootId && typeof node.id === "string") {
		idMap[node.id] = rootId;
		clone.id = rootId;
	}

	const remapReferences = (value) => {
		if (Array.isArray(value)) {
			value.forEach(remapReferences);
			return;
		}
		if (!isPlainObject(value)) {
			return;
		}
		if (typeof value.parentId === "string" && idMap[value.parentId]) {
			value.parentId = idMap[value.parentId];
		}
		Object.keys(value).forEach((key) => remapReferences(value[key]));
	};
	remapReferences(clone);

	return clone;
};

const insertAfter = (collection, afterId, item) => {
	const index = collection.findIndex((entry) => entry.id === afterId);
	if (index === -1) {
		return [...collection, item];
	}
	return [
		...collection.slice(0, index + 1),
		item,
		...collection.slice(index + 1),
	];
};

const withDuplicatedGridColumn = (firstLevel, components, blockId) => {
	const columns = firstLevel?.styles?.gridTemplateColumns;
	if (
		!GRID_COLUMN_CONTAINERS.includes(firstLevel?.name) ||
		!Array.isArray(columns)
	) {
		return {};
	}
	const index = components.findIndex((item) => item.id === blockId);
	if (index === -1) {
		return {};
	}
	const nextColumns = [...columns];
	nextColumns.splice(index + 1, 0, columns[index] ?? "1fr");
	return {
		styles: { ...firstLevel.styles, gridTemplateColumns: nextColumns },
	};
};

/**
 * Дублирует компонент по пути id и кладёт копию сразу после оригинала.
 * Работает на трёх уровнях: контейнер [id], блок/слайд [id, id],
 * элемент [id, id, id]. rootId — id копии, его же редактор делает активным.
 * Если путь не найден, возвращаем коллекцию как есть: лучше ничего не сделать,
 * чем положить в дерево undefined.
 */
export const duplicateComponent = (componentCollection, id, rootId) => {
	if (!id?.length) {
		return componentCollection;
	}

	if (id.length === 1) {
		const original = componentCollection.find((item) => item.id === id[0]);
		if (!original) {
			console.error(
				`[editorHelpers] duplicateComponent: контейнер "${id[0]}" не найден`
			);
			return componentCollection;
		}
		return insertAfter(
			componentCollection,
			id[0],
			cloneWithNewIds(original, rootId)
		);
	}

	const firstLevel = componentCollection.find((item) => item.id === id[0]);
	const twoLevelComponents = firstLevel?.components;

	if (!Array.isArray(twoLevelComponents)) {
		console.error(
			`[editorHelpers] duplicateComponent: у контейнера "${id[0]}" нет components`
		);
		return componentCollection;
	}

	if (id.length === 2) {
		const original = twoLevelComponents.find((item) => item.id === id[1]);
		if (!original) {
			console.error(
				`[editorHelpers] duplicateComponent: блок "${id[1]}" не найден`
			);
			return componentCollection;
		}
		return getResult(componentCollection, id[0], {
			...firstLevel,
			...withDuplicatedGridColumn(firstLevel, twoLevelComponents, id[1]),
			components: insertAfter(
				twoLevelComponents,
				id[1],
				cloneWithNewIds(original, rootId)
			),
		});
	}

	if (id.length === 3) {
		const twoLevel = twoLevelComponents.find((item) => item.id === id[1]);
		const threeLevelComponents = twoLevel?.components;
		const original = threeLevelComponents?.find((item) => item.id === id[2]);
		if (!original) {
			console.error(
				`[editorHelpers] duplicateComponent: элемент "${id[2]}" не найден`
			);
			return componentCollection;
		}
		return getResult(componentCollection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: insertAfter(
					threeLevelComponents,
					id[2],
					cloneWithNewIds(original, rootId)
				),
			}),
		});
	}

	console.error(
		`[editorHelpers] duplicateComponent: неподдерживаемая глубина пути (${id.length})`
	);
	return componentCollection;
};

export const changePosition = (collection, id, direction) => {
	const change = (position, collection) => {
		if (direction === "up") {
			[collection[position], collection[position - 1]] = [
				collection[position - 1],
				collection[position],
			];
		}
		if (direction === "down") {
			[collection[position], collection[position + 1]] = [
				collection[position + 1],
				collection[position],
			];
		}
		return [...collection];
	};
	if (id?.length === 1) {
		let position = collection.findIndex((item) => item.id === id[0]);
		return change(position, collection);
	}
	if (id?.length === 3) {
		let firstLevel = collection.filter((item) => item.id === id[0])[0];
		let twoLevelComponents = firstLevel.components;
		let twoLevel = twoLevelComponents?.filter((item) => item.id === id[1])[0];
		let threeLevelComponents = twoLevel?.components;
		let position = threeLevelComponents.findIndex(
			(item) => item.id === id[2]
		);
		return getResult(collection, id[0], {
			...firstLevel,
			components: getResult(twoLevelComponents, id[1], {
				...twoLevel,
				components: change(position, threeLevelComponents),
			}),
		});
	}
};

export const chageImageFull = (collection, id, flag) => {
	let firstLevel = collection.filter((item) => item.id === id)[0];
	let itemForChanged = { ...firstLevel, fullImg: flag };
	let result = [];
	for (let item of collection) {
		if (item.id === id) {
			result = [...result, itemForChanged];
		} else {
			result = [...result, item];
		}
	}
	return result;
};
